const FRAME_INTERVAL_MS = 1000 / 30
const BASE_FREQUENCY_X = 0.018
const BASE_FREQUENCY_Y = 0.085
const AMPLITUDE_X = 0.004
const AMPLITUDE_Y = 0.015
// Incommensurate periods keep the drift from visibly looping.
const PERIOD_X_MS = 9000
const PERIOD_Y_MS = 13000

const turbulenceElements = new Set<SVGFETurbulenceElement>()
let frameHandle: number | null = null
let lastFrameAt = 0

const prefersReducedMotion = () =>
   window.matchMedia('(prefers-reduced-motion: reduce)').matches

/**
 * Writes the current noise frequency to every registered flame filter.
 *
 * @param timestamp - The animation-frame timestamp.
 */
function renderFrame(timestamp: number) {
   frameHandle = turbulenceElements.size > 0 ? requestAnimationFrame(renderFrame) : null
   // Allow 1 ms of slack: two 60 Hz frames land just under the 30 fps interval.
   if (timestamp - lastFrameAt < FRAME_INTERVAL_MS - 1 || prefersReducedMotion()) {
      return
   }
   lastFrameAt = timestamp

   const x =
      BASE_FREQUENCY_X + AMPLITUDE_X * Math.sin((timestamp / PERIOD_X_MS) * 2 * Math.PI)
   const y =
      BASE_FREQUENCY_Y +
      AMPLITUDE_Y * Math.sin((timestamp / PERIOD_Y_MS) * 2 * Math.PI + 1)
   const baseFrequency = `${x.toFixed(4)} ${y.toFixed(4)}`
   for (const element of turbulenceElements) {
      element.setAttribute('baseFrequency', baseFrequency)
   }
}

/**
 * Animates a flame filter's noise with one shared, steady-paced frame loop,
 * replacing SMIL whose pacing is uneven in some Chromium builds at startup.
 *
 * @param element - The flame filter's turbulence primitive.
 * @returns A function that stops animating the element.
 */
export function animateFlame(element: SVGFETurbulenceElement) {
   turbulenceElements.add(element)
   frameHandle ??= requestAnimationFrame(renderFrame)
   return () => {
      turbulenceElements.delete(element)
   }
}
